import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multi-check',
  templateUrl: './multi-check.component.html',
  styleUrls: ['./multi-check.component.css']
})
export class MultiCheckComponent implements OnInit {
  @Input() field: any;
  @ViewChild('f') form: any;
  @ViewChild('invalidTooltip') invalidTooltip: NgbTooltip;

  constructor() { }

  ngOnInit() {
    this.field.value = {};
    // console.log(this.form);

    //listening input state changes
    this.form.statusChanges.subscribe(status => {
      // console.log(status);
      if (status == 'INVALID' && (this.form.dirty || this.form.touched)) {
        this.invalidTooltip.open();
      }
      if (status == 'VALID') {
        this.invalidTooltip.close();
      }
    });

    //pass formcontrol to field obj
    this.field.formControl = this.form.form;
    this.field.invalidTooltip = this.invalidTooltip;
  }

  isRequired(index) {
    if (!this.field.required) {
      return false;
    }
    for (let key in this.field.value) {
      if (this.field.value[key]) {
        return false;
      }
    }

    return true;
  }

}
